<script setup>
import { ref, computed, watch } from 'vue';
import { useI18n } from "vue-i18n";

const emit = defineEmits(['allValid'])
const props = defineProps({
    password: {
        type: String,
        required: true
    },
    password_confirmation: {
        type: String,
        required: false,
    },
    password_confirmation_required: {
        type: Boolean,
        default: false,
        required: false
    }
});

// I18n
const { t } = useI18n();

const passwordRequirements = computed(() => {
    const requirements = [
        { requirement: t('modal.sign_up.password_requirements.requirement_1'), valid: props.password.length >= 8 },
        { requirement: t('modal.sign_up.password_requirements.requirement_2'), valid: /[a-z]/.test(props.password) },
        { requirement: t('modal.sign_up.password_requirements.requirement_3'), valid: /[A-Z]/.test(props.password) },
        { requirement: t('modal.sign_up.password_requirements.requirement_4'), valid: /\d/.test(props.password) },
        { requirement: t('modal.sign_up.password_requirements.requirement_5'), valid: /[!@#$%^&*+]/.test(props.password) },
    ];
    
    if (props.password_confirmation_required) {
        requirements.push({
            requirement: t('modal.sign_up.password_requirements.requirement_7'),
            valid: props.password === props.password_confirmation && props.password.length > 0
        });
    }
    
    return requirements;
});

const allValid = computed(() => passwordRequirements.value.every(requirement => requirement.valid));

// Watch for changes and emit the validation state immediately to parent component
// This ensures the sign up form knows when password validation changes
watch(allValid, (newValue) => {
    emit('allValid', newValue);
}, { immediate: true });

</script>

<template>
    <div>
        <ul class="mb-4">
        <p>Password must:</p>
        <li
            v-for="(requirement, index) in passwordRequirements"
            :key="index"
            :class="{ 'text-red-600': !requirement.valid, 'text-green-500': requirement.valid }"
            class="flex items-center"
        >
            <span class="mr-2" :class="{ 'text-red-600': !requirement.valid, 'text-green-500': requirement.valid }">{{ requirement.valid ? "✓" : "✗" }}</span>
            <span :class="{ 'text-red-600': !requirement.valid, 'text-gray-600': requirement.valid }">{{ requirement.requirement }}</span>
        </li>
        </ul>
    </div>
</template>